module.exports = __webpack_public_path__ + "img/enhancer1.c8c45fb3.webp";